<template>
  <main class="cover-auth">
    <div class="widget-auth">
      <h2 class="font-bold text-center my-6">
        Félicitation votre compte <br/>
        <span class="text-3xl text-primary-color">COOP FINANCE</span> a été créé
      </h2>
      
      <div class="text-center mb-8 px-10">
        <img 
          :src="statusImage" 
          class="auth-logo" 
          alt="Statut de création de compte" 
        />
      </div>
      
      <h3 class="font-normal text-grey-800 text-center pb-5">
        {{ statusMessage }}
      </h3>

      <div v-if="showActions" class="mt-6">
        <button
          @click="goToDashboard"
          class="btn lg w-100 flex-center mb-4"
        >
          <img src="/public/icons/icon-valider.svg" class="btn-icon" alt="" />
          <span>Se connecter</span>
        </button>
      </div>
    </div>
  </main>
</template>

<script lang="ts">
import { defineComponent, computed } from 'vue'
import { useRouter } from 'vue-router'

export default defineComponent({
  name: 'SignUpBack',
  props: {
    status: {
      type: String,
      default: 'success', // 'success' ou 'fail'
      validator: (value: string) => ['success', 'fail'].includes(value)
    },
    email: {
      type: String,
      default: ''
    }
  },
  setup(props) {
    const router = useRouter()

    const statusImage = computed(() => {
      return props.status === 'success' 
        ? '/public/images/sign-up-success.svg'
        : '/public/images/sign-up-fail.svg'
    })

    const statusMessage = computed(() => {
      if (props.status === 'success') {
        return 'Votre compte a été créé avec succès ! Vous pouvez maintenant accéder à votre espace membre.'
      } else {
        return 'Une erreur est survenue lors de la création de votre compte. Veuillez réessayer.'
      }
    })

    const showActions = computed(() => {
      return props.status === 'success'
    })

    const goToDashboard = () => {
      // Nettoyer les données d'invitation du sessionStorage
      sessionStorage.removeItem('invitation_user_id')
      sessionStorage.removeItem('invitation_user_salaire')
      sessionStorage.removeItem('invitation_user_nom')
      sessionStorage.removeItem('invitation_user_prenom')
      sessionStorage.removeItem('invitation_user_email')
      sessionStorage.removeItem('invitation_user_telephone')
      sessionStorage.removeItem('invitation_user_collectivite')

      // Rediriger vers la page de connexion
      router.push('/auth/sign-in')
    }

    return {
      statusImage,
      statusMessage,
      showActions,
      goToDashboard
    }
  }
})
</script>

<style scoped>
.auth-logo {
  max-width: 100%;
  height: auto;
  animation: fadeIn 0.5s ease-in-out;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.btn-outline {
  background: transparent;
  border: 2px solid var(--primary-color, #007bff);
  color: var(--primary-color, #007bff);
}

.btn-outline:hover {
  background: var(--primary-color, #007bff);
  color: white;
}

.btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
</style>

